// extracted by mini-css-extract-plugin
export default {"preferences":"uwu0P","oneClickActive":"IJP9a"};